import React, { MouseEventHandler, useEffect, useState } from "react";
import IconButton from "../common/IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import cn from "classnames";
import { getPathValue } from "src/utils/queryStringUtil";

interface PageProp {
  current_page?: number;
  item_count?: number | any;
  total_page?: number | any;
  objectChange?: any;
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
  viewName?: string;
  apiSuccess?: boolean;
}

const PaginationCommon = (props: PageProp) => {
  const group_index: any = getPathValue();

  const [activeIndex, setActiveIndex] = useState<any>(props.current_page === 0 || props.current_page === undefined ? 1 : props.current_page);
  // 새로운 검색이 있을시

  useEffect(() => {
    // if (props.viewName === "manage") {
    //   setActiveIndex(props.current_page);
    // } else if (props.viewName === "manageList") {
    //   setActiveIndex(props.current_page);
    // } else if (props.viewName === "noticeList") {
    //   setActiveIndex(props.current_page);
    // }
    setActiveIndex(props.current_page);
  }, [props.current_page]);

  useEffect(() => {
    // 새로운 페이지번호 클릭시 스크롤 상단 이동
    window.scrollTo(0, 0);
  }, [activeIndex]);

  const numberClick = (value: number) => {
    setActiveIndex(value);
    props.objectChange(value);
  };

  const firstPageClick = () => {
    props.objectChange(1);
    setActiveIndex(1);
  };

  const lastPageClick = () => {
    props.objectChange(props.total_page);
    setActiveIndex(props.total_page);
  };

  const beforeClick = () => {
    if (1 < activeIndex) {
      const minusValue = Number(activeIndex) - 1;
      props.objectChange(minusValue);
      setActiveIndex(minusValue);
    }
  };

  const afterClick = () => {
    if (props.total_page > activeIndex) {
      const sumValue = Number(activeIndex) + 1;
      props.objectChange(sumValue);
      setActiveIndex(sumValue);
    }
  };

  const startPage = (start: number) => {
    return (Math.ceil(start / 5) - 1) * 5 + 1;
  };
  const endPage = (start: number, total: number) => {
    if (total < 5) {
      return total;
    }
    const end = (Math.ceil(start / 5) - 1) * 5 + 1 + 4;
    if (end > total) {
      return total;
    } else {
      return end;
    }
  };

  const pageView = () => {
    const row: any = [];
    for (let i = startPage(activeIndex); i < endPage(activeIndex, props.total_page) + 1; i++) {
      row.push(
        <li
          className={cn({ active: Number(activeIndex) === i })}
          key={i}
          onClick={() => {
            numberClick(i);
            // props.onClick();
          }}
        >
          <span>{i}</span>
        </li>,
      );
    }
    return <> {row} </>;
  };

  return (
    <PaginationSet>
      <li className={cn({ hide: activeIndex === 1 })}>
        <IconButton
          btnName="첫페이지"
          onClick={() => {
            firstPageClick();
          }}
        >
          <SVG name="pageFirst" width={40} height={40} viewBox="0 0 40 40" />
        </IconButton>
      </li>
      <li className={cn({ hide: activeIndex === 1 })}>
        <IconButton
          btnName="이전페이지"
          onClick={() => {
            // props.onClick();
            beforeClick();
          }}
        >
          <SVG name="pageLeft" width={40} height={40} viewBox="0 0 40 40" />
        </IconButton>
      </li>
      {pageView()}
      <li className={cn({ hide: activeIndex === props.total_page })}>
        <IconButton
          btnName="다음페이지"
          onClick={() => {
            // props.onClick();
            afterClick();
          }}
        >
          <SVG name="pageRight" width={40} height={40} viewBox="0 0 40 40" />
        </IconButton>
      </li>
      <li className={cn({ hide: activeIndex === props.total_page })}>
        <IconButton
          btnName="마지막페이지"
          onClick={() => {
            lastPageClick();
          }}
        >
          <SVG name="pageLast" width={40} height={40} viewBox="0 0 40 40" />
        </IconButton>
      </li>
    </PaginationSet>
  );
};

const PaginationSet = styled.ul`
  ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
  margin-top: 28px;
  > li {
    width: 40px;
    height: 40px;
    ${({ theme }) => theme.flexBox.flexMixin("row", "center", "center")}
    > span {
      color: #ccc;
      font-family: "Poppins";
      font-weight: 500;
      font-size: 18px;
    }
    > button {
      top: -1px;
    }
    &.active {
      > span {
        color: ${({ theme }) => theme.color.main};
        font-weight: 700;
      }
    }
    &.hide {
      opacity: 0.3;
    }
  }
`;

export default PaginationCommon;
